import Qwiic from "../../../../docs/_images/BME280.png";
import * as React from 'react';
export default {
  Qwiic,
  React
};